import { Model } from './_model';

export default class Transfer extends Model {
  get defaults() {
    return {
      ...this.transferInstruction, ...this.authorization
    }
  }

  get transferInstruction() {
    return {
      salutation: '',
      title: '',
      firstName: '',
      lastName: '',
      middleName: '',
      emailAddress: '',
      transferAmount: '',
      purchaseDate: '',
      taxStatus: '',
      graduatedTaxStatus: '',
      transferDate: '',
      settlementDate: '',
    }
  }

  get authorization() {
    return {
      fromRegistryBpId: '',
      fromRegistryAccountNumber: '',
      toType: '',
      toDepositoryBpId: '',
      toDepositoryAccountNumber: '',
      toRegistryBpId: '',
      toRegistryAccountNumber: '',
      nonStockProfit: '',
      toTaxStatus: '',
      toGraduatedTaxStatus: ''
    }
  }
}






